/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLFlnN%7Balign-items%3Astretch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAjtAN%7Bmin-height%3Avar(--link-picker-min-height)%7D");
import React, { forwardRef } from 'react';
type MinHeightContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  minHeight: string;
};
const minHeightComponentStyles = null;
export const MinHeightContainer: React.ForwardRefExoticComponent<React.HTMLAttributes<HTMLDivElement> & {
  minHeight: string;
} & React.RefAttributes<HTMLDivElement>> = forwardRef<HTMLDivElement, MinHeightContainerProps>(({
  className,
  minHeight,
  ...props
}: MinHeightContainerProps, ref) => {
  return <div ref={ref}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax(["_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN", className])} {...props} style={{
    [('--link-picker-min-height' as string)]: minHeight
  }} />;
});